import { Routes, Route } from 'react-router-dom';
import { Notifications } from '@mantine/notifications';
import { AppShell } from '@mantine/core';

import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { ResumePage } from './pages/ResumePage';
import { ProjectsPage } from './pages/ProjectsPage';
import { ProjectDetailPage } from './pages/ProjectDetailPage';
import { TabletopGamingPage } from './pages/TabletopGamingPage';
import { AstrophotographyPage } from './pages/AstrophotographyPage';
import { ContactPage } from './pages/ContactPage';

import { DevStatsPage } from './pages/DevStatsPage';
import { NotFoundPage } from './pages/NotFoundPage';

export function App() {
  return (
    <>
      <Notifications />
      <AppShell>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/resume" element={<ResumePage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/projects/:slug" element={<ProjectDetailPage />} />
            <Route path="/tabletop" element={<TabletopGamingPage />} />
            <Route path="/astrophotography" element={<AstrophotographyPage />} />
            <Route path="/contact" element={<ContactPage />} />

            <Route path="/dev-stats" element={<DevStatsPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Layout>
      </AppShell>
    </>
  );
}
